import constants from "./constants";
import { getDomain } from "tldts";
export function getAppDomain() {
  var domainList = constants.envDomain.split(",");
  var absoluteDomain = "";
  for (var i = 0; i < domainList.length; i++) {
    if (getDomain(window.location.href) === domainList[i].trim()) {
      var absoluteDomain = domainList[i].trim();
      console.log("app domain", absoluteDomain);
      return absoluteDomain;
    }
  }
}

// export function getMainDomain(url) {
//     return fromUrl(url).domain || "";
// }
// export default getAppDomain;
